(function () {
  if (typeof window === "undefined") return;

  window._ctl_loaded = window._ctl_loaded || {
    ga: false,
    hotjar: false,
    bing: false,
    youtube: false,
    facebook: false
  };

  function getSettings() {
    return window.CTL_SETTINGS || {};
  }

  function sentryCapture(payload) {
    if (typeof window.stompSentryCapture === "function") {
      window.stompSentryCapture(payload || {});
    }
  }

  function logConsentIssue(code, message, extra) {
    var metadata = extra || {};
    sentryCapture({
      level: "warning",
      message: "[CookieConsent][" + code + "] " + message,
      tags: {
        area: "cookie-consent",
        issue_code: code
      },
      extra: metadata
    });
  }

  function logConsentError(code, error, extra) {
    var metadata = extra || {};
    sentryCapture({
      level: "error",
      message: "[CookieConsent][" + code + "] runtime error",
      error: error,
      tags: {
        area: "cookie-consent",
        error_code: code
      },
      extra: metadata
    });
  }

  function getDomains() {
    var parts = location.hostname.split(".");
    var domains = [];
    var i;

    for (i = 0; i < parts.length; i += 1) {
      var d = parts.slice(i).join(".");
      domains.push(d, "." + d);
    }

    return Array.from(new Set(domains));
  }

  var SHOPIFY_CONSENT_COOKIES = {
    performance: ["_shopify_analytics", "_shopify_s", "_shopify_y"],
    functional: ["cart_currency", "localization"],
    targeting: ["_shopify_marketing"]
  };

  // C0004 Targeting — Klaviyo + Yotpo marketing pixel.
  var TARGETING_APP_COOKIES = ["__kla_id", "__kla_session", "yotpo_pixel"];

  // C0002 Performance — Yotpo widget analytics (Snowplow-format cookies).
  var PERFORMANCE_APP_COOKIE_PREFIXES = ["_sp_id", "_sp_ses"];

  var TARGETING_LOCAL_STORAGE_KEYS = [
    "_uetsid",
    "_uetsid_exp",
    "_uetvid",
    "_uetvid_exp",
    "_gcl_ls",
    "lastExternalReferrer",
    "lastExternalReferrerTime",
    "$last_referrer",
    "$referrer",
    "__kl_key",
    "kl-post-identification-sync",
    "klaviyoOnsite"
  ];

  var TARGETING_LOCAL_STORAGE_PREFIXES = ["klaviyo"];

  var FUNCTIONAL_LOCAL_STORAGE_KEYS = [
    "shopify:webmcp_adapter_loaded"
  ];

  var FUNCTIONAL_LOCAL_STORAGE_PREFIXES = ["asklayer_", "gorgias."];

  var SIGN_IN_WITH_SHOP_PREFIX = "signInWithShop:";

  // C0001 — never remove during consent cleanup.
  var STRICTLY_NECESSARY_LOCAL_STORAGE_KEYS = [
    "signInWithShop:cartSyncTransferAttemptedAt"
  ];

  var POST_LOAD_LOCAL_STORAGE_CLEANUP_MS = 2000;
  var postLoadLocalStorageCleanupTimer = null;

  var PERFORMANCE_SESSION_STORAGE_KEYS = [
    "__shopify_agent_context_events",
    "_shs_state",
    "_cltk"
  ];

  var FUNCTIONAL_SESSION_STORAGE_PREFIXES = ["asklayer_", "gorgias.", "__smile_"];

  var TARGETING_SESSION_STORAGE_KEYS = [
    "klaviyoPagesVisitCountV2",
    "sentSessionStartedEvent"
  ];

  var TARGETING_SESSION_STORAGE_PREFIXES = ["ri-", "wpm-ri-", "klaviyo"];

  // C0001 — never remove during consent cleanup.
  var STRICTLY_NECESSARY_SESSION_STORAGE_KEYS = [
    "consentHeader"
  ];

  var POST_LOAD_SESSION_STORAGE_CLEANUP_MS = 2000;
  var postLoadSessionStorageCleanupTimer = null;

  var REJECTED_CONSENT_STATE = {
    performance: false,
    functional: false,
    targeting: false
  };

  // HttpOnly Shopify cookies (_shopify_analytics, _shopify_marketing) can only be
  // suppressed via Shopify.customerPrivacy.setTrackingConsent(), not document.cookie.
  var customerPrivacyReadyQueue = [];
  var customerPrivacyReadyState = "pending";

  function ensureCustomerPrivacyReady(callback) {
    if (customerPrivacyReadyState === "ready" && window.Shopify && window.Shopify.customerPrivacy) {
      if (typeof callback === "function") callback(true);
      return;
    }

    if (typeof callback === "function") {
      customerPrivacyReadyQueue.push(callback);
    }

    if (customerPrivacyReadyState === "loading") {
      return;
    }

    customerPrivacyReadyState = "loading";

    function finish(success) {
      customerPrivacyReadyState = success ? "ready" : "failed";
      var queue = customerPrivacyReadyQueue.slice();
      customerPrivacyReadyQueue = [];

      queue.forEach(function (cb) {
        cb(success);
      });
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        function (error) {
          if (error) {
            logConsentError("CUSTOMER_PRIVACY_LOAD_FAILED", error);
            finish(false);
            return;
          }

          finish(Boolean(window.Shopify && window.Shopify.customerPrivacy));
        }
      );
      return;
    }

    if (window.Shopify && window.Shopify.customerPrivacy) {
      finish(true);
      return;
    }

    logConsentIssue("CUSTOMER_PRIVACY_UNAVAILABLE", "Shopify Customer Privacy API was not found on page load");
    finish(false);
  }

  function deleteCookie(name) {
    var domains = getDomains();
    var paths = ["/", ""];
    var i;
    var j;
    var k;

    for (i = 0; i < domains.length; i += 1) {
      for (j = 0; j < paths.length; j += 1) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + (paths[j] || "/") + "; domain=" + domains[i] + ";";
      }
    }

    for (k = 0; k < paths.length; k += 1) {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=" + (paths[k] || "/") + ";";
    }
  }

  function deleteNamedCookies(names) {
    var list = Array.isArray(names) ? names : [names];
    var i;

    for (i = 0; i < list.length; i += 1) {
      deleteCookie(list[i]);
    }
  }

  function isProtectedLocalStorageKey(key) {
    return STRICTLY_NECESSARY_LOCAL_STORAGE_KEYS.indexOf(key) > -1;
  }

  function deleteLocalStorageKeys(keys) {
    var list = Array.isArray(keys) ? keys : [keys];
    var i;

    try {
      for (i = 0; i < list.length; i += 1) {
        if (isProtectedLocalStorageKey(list[i])) {
          continue;
        }

        localStorage.removeItem(list[i]);
      }
    } catch (err) {
      logConsentError("LOCAL_STORAGE_DELETE_FAILED", err, { keys: list });
    }
  }

  function deleteLocalStorageByPrefixes(prefixes) {
    var list = Array.isArray(prefixes) ? prefixes : [prefixes];
    var keys;
    var i;
    var j;

    try {
      keys = Object.keys(localStorage);
      for (i = 0; i < keys.length; i += 1) {
        if (isProtectedLocalStorageKey(keys[i])) {
          continue;
        }

        for (j = 0; j < list.length; j += 1) {
          if (keys[i].indexOf(String(list[j])) === 0) {
            localStorage.removeItem(keys[i]);
            break;
          }
        }
      }
    } catch (err) {
      logConsentError("LOCAL_STORAGE_PREFIX_DELETE_FAILED", err, { prefixes: list });
    }
  }

  function resolveConsentState(consentState) {
    return {
      performance: consentState && typeof consentState.performance === "boolean"
        ? consentState.performance
        : isAllowed("C0002"),
      functional: consentState && typeof consentState.functional === "boolean"
        ? consentState.functional
        : isAllowed("C0003"),
      targeting: consentState && typeof consentState.targeting === "boolean"
        ? consentState.targeting
        : isAllowed("C0004")
    };
  }

  function deleteNonProtectedSignInWithShopLocalStorage() {
    var keys;
    var i;

    try {
      keys = Object.keys(localStorage);
      for (i = 0; i < keys.length; i += 1) {
        if (keys[i].indexOf(SIGN_IN_WITH_SHOP_PREFIX) !== 0) {
          continue;
        }

        if (isProtectedLocalStorageKey(keys[i])) {
          continue;
        }

        localStorage.removeItem(keys[i]);
      }
    } catch (err) {
      logConsentError("LOCAL_STORAGE_SHOP_PAY_DELETE_FAILED", err);
    }
  }

  // Runs on first page load, every refresh, and every consent change.
  // Deletes keys by name/prefix only when the matching category consent is not granted.
  function applyLocalStorageConsent(consentState) {
    var state = resolveConsentState(consentState || {});

    // C0004 Targeting — keep only when targeting consent is granted.
    if (!state.targeting) {
      deleteLocalStorageKeys(TARGETING_LOCAL_STORAGE_KEYS);
    }

    // C0003 Functional — keep only when functional consent is granted.
    if (!state.functional) {
      deleteLocalStorageKeys(FUNCTIONAL_LOCAL_STORAGE_KEYS);
      deleteLocalStorageByPrefixes(FUNCTIONAL_LOCAL_STORAGE_PREFIXES);
    }

    // Non-protected Shop Pay keys are not strictly necessary (C0001 allowlist above).
    if (!state.functional || !state.targeting) {
      deleteNonProtectedSignInWithShopLocalStorage();
    }
  }

  function deleteTargetingLocalStorage(consentState) {
    applyLocalStorageConsent(consentState);
  }

  function schedulePostLoadLocalStorageCleanup(consentState) {
    var state = resolveConsentState(consentState || {});

    if (state.functional && state.targeting) {
      if (postLoadLocalStorageCleanupTimer) {
        window.clearTimeout(postLoadLocalStorageCleanupTimer);
        postLoadLocalStorageCleanupTimer = null;
      }
      return;
    }

    if (postLoadLocalStorageCleanupTimer) {
      window.clearTimeout(postLoadLocalStorageCleanupTimer);
    }

    postLoadLocalStorageCleanupTimer = window.setTimeout(function () {
      postLoadLocalStorageCleanupTimer = null;
      applyLocalStorageConsent(consentState);
      applyAppEmbedCookieConsent(consentState);
    }, POST_LOAD_LOCAL_STORAGE_CLEANUP_MS);
  }

  function isProtectedSessionStorageKey(key) {
    return STRICTLY_NECESSARY_SESSION_STORAGE_KEYS.indexOf(key) > -1;
  }

  function deleteSessionStorageKeys(keys) {
    var list = Array.isArray(keys) ? keys : [keys];
    var i;

    try {
      for (i = 0; i < list.length; i += 1) {
        if (isProtectedSessionStorageKey(list[i])) {
          continue;
        }

        sessionStorage.removeItem(list[i]);
      }
    } catch (err) {
      logConsentError("SESSION_STORAGE_DELETE_FAILED", err, { keys: list });
    }
  }

  function deleteSessionStorageByPrefixes(prefixes) {
    var list = Array.isArray(prefixes) ? prefixes : [prefixes];
    var keys;
    var i;
    var j;

    try {
      keys = Object.keys(sessionStorage);
      for (i = 0; i < keys.length; i += 1) {
        if (isProtectedSessionStorageKey(keys[i])) {
          continue;
        }

        for (j = 0; j < list.length; j += 1) {
          if (keys[i].indexOf(String(list[j])) === 0) {
            sessionStorage.removeItem(keys[i]);
            break;
          }
        }
      }
    } catch (err) {
      logConsentError("SESSION_STORAGE_PREFIX_DELETE_FAILED", err, { prefixes: list });
    }
  }

  // Runs on first page load, every refresh, and every consent change.
  // Deletes keys by name/prefix only when the matching category consent is not granted.
  function applySessionStorageConsent(consentState) {
    var state = resolveConsentState(consentState || {});

    // C0002 Performance — keep only when performance consent is granted.
    if (!state.performance) {
      deleteSessionStorageKeys(PERFORMANCE_SESSION_STORAGE_KEYS);
    }

    // C0004 Targeting — keep only when targeting consent is granted.
    if (!state.targeting) {
      deleteSessionStorageKeys(TARGETING_SESSION_STORAGE_KEYS);
      deleteSessionStorageByPrefixes(TARGETING_SESSION_STORAGE_PREFIXES);
    }

    // C0003 Functional — keep only when functional consent is granted.
    if (!state.functional) {
      deleteSessionStorageByPrefixes(FUNCTIONAL_SESSION_STORAGE_PREFIXES);
    }
  }

  function schedulePostLoadSessionStorageCleanup(consentState) {
    var state = resolveConsentState(consentState || {});

    if (state.performance && state.functional && state.targeting) {
      if (postLoadSessionStorageCleanupTimer) {
        window.clearTimeout(postLoadSessionStorageCleanupTimer);
        postLoadSessionStorageCleanupTimer = null;
      }
      return;
    }

    if (postLoadSessionStorageCleanupTimer) {
      window.clearTimeout(postLoadSessionStorageCleanupTimer);
    }

    postLoadSessionStorageCleanupTimer = window.setTimeout(function () {
      postLoadSessionStorageCleanupTimer = null;
      applySessionStorageConsent(consentState);
      applyAppEmbedCookieConsent(consentState);
    }, POST_LOAD_SESSION_STORAGE_CLEANUP_MS);
  }

  function deleteCookiesByPrefixes(prefixes) {
    var list = Array.isArray(prefixes) ? prefixes : [prefixes];
    var cookies = document.cookie ? document.cookie.split(";") : [];

    cookies.forEach(function (entry) {
      var name = entry.split("=")[0].trim();
      list.forEach(function (prefix) {
        if (name.toLowerCase().indexOf(String(prefix).toLowerCase()) === 0) {
          deleteCookie(name);
        }
      });
    });
  }

  function getGroups() {
    var match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]+)/);
    if (match) {
      var decoded = decodeURIComponent(match[1]);
      var groupsMatch = decoded.match(/groups=([^&]+)/);
      if (groupsMatch && groupsMatch[1]) {
        return groupsMatch[1];
      }
    }

    if (typeof window.OnetrustActiveGroups === "string" && window.OnetrustActiveGroups.length) {
      return window.OnetrustActiveGroups;
    }

    return "";
  }

  function getConsentSnapshot() {
    return {
      groups: getGroups(),
      performance: isAllowed("C0002"),
      functional: isAllowed("C0003"),
      targeting: isAllowed("C0004")
    };
  }

  function isAllowed(group) {
    var groups = getGroups();
    if (!groups) return false;

    // Support both OneTrust formats:
    // 1) "C0002:1,C0003:1"
    // 2) ",C0001,C0002,C0003,"
    if (groups.indexOf(group + ":1") > -1) return true;

    var normalized = String(groups).replace(/\s+/g, "");
    var wrapped = "," + normalized + ",";
    return wrapped.indexOf("," + group + ",") > -1;
  }

  function isConsentGroupAllowed(group) {
    return isAllowed(group);
  }

  function syncShopifyConsent() {
    ensureCustomerPrivacyReady(function (ready) {
      if (!ready || !window.Shopify || !Shopify.customerPrivacy) {
        return;
      }

      var analytics = isAllowed("C0002");
      var preferences = isAllowed("C0003");
      var marketing = isAllowed("C0004");

      Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: analytics,
          preferences: preferences,
          marketing: marketing,
          sale_of_data: true
        },
        function () {
          deleteShopifyBuiltInCookies({
            performance: analytics,
            functional: preferences,
            targeting: marketing
          });
        }
      );
    });
  }

  function loadScriptOnce(key, src, callback) {
    if (!src || window._ctl_loaded[key]) return;
    if (document.querySelector('script[data-ctl-key="' + key + '"]')) {
      window._ctl_loaded[key] = true;
      return;
    }

    var s = document.createElement("script");
    s.async = true;
    s.src = src;
    s.setAttribute("data-ctl-key", key);

    s.onload = function () {
      window._ctl_loaded[key] = true;
      if (typeof callback === "function") callback();
    };

    s.onerror = function (e) {
      window._ctl_loaded[key] = false;
      sentryCapture({
        level: "error",
        message: "[CookieConsent] Failed to load third-party script",
        tags: {
          area: "cookie-consent",
          vendor_key: key
        },
        extra: {
          script_src: src
        }
      });
    };

    document.head.appendChild(s);
  }

  function mountSmileInitializer() {
    if (document.querySelector("[data-ctl-smile-mounted='true']")) return;

    var template = document.getElementById("smile-init-template");
    if (!template || !template.content) return;

    var wrapper = document.createElement("div");
    wrapper.setAttribute("data-ctl-smile-mounted", "true");
    wrapper.appendChild(template.content.cloneNode(true));
    document.body.appendChild(wrapper);
  }

  function unmountSmileInitializer() {
    var mounted = document.querySelector("[data-ctl-smile-mounted='true']");
    if (mounted) {
      mounted.remove();
    }
  }

  function loadGA() {
    var settings = getSettings();
    if (!settings.ga_measurement_id) return;

    window["ga-disable-" + settings.ga_measurement_id] = false;

    loadScriptOnce("ga", "https://www.googletagmanager.com/gtag/js?id=" + settings.ga_measurement_id, function () {
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag("js", new Date());
      window.gtag("config", settings.ga_measurement_id, { send_page_view: false });
    });
  }

  function disableGA() {
    var settings = getSettings();
    window._ctl_loaded.ga = false;

    if (settings.ga_measurement_id) {
      window["ga-disable-" + settings.ga_measurement_id] = true;
    }

    deleteCookiesByPrefixes(["_ga", "_gid", "_gat", "_gcl", "_gac", "_gads", "_gpi"]);
  }

  function loadHotjar() {
    var settings = getSettings();
    if (!settings.hotjar || !settings.hotjar_id || window._ctl_loaded.hotjar) return;

    window._ctl_loaded.hotjar = true;
    (function (h, o, t, j, a, r) {
      h.hj = h.hj || function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
      h._hjSettings = { hjid: settings.hotjar_id, hjsv: 6 };
      a = o.getElementsByTagName("head")[0];
      r = o.createElement("script");
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      r.setAttribute("data-ctl-key", "hotjar");
      a.appendChild(r);
    })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
  }

  function disableHotjar() {
    window._ctl_loaded.hotjar = false;
    deleteCookiesByPrefixes(["_hj"]);
    document.querySelectorAll('script[src*="hotjar"],script[data-ctl-key="hotjar"]').forEach(function (script) {
      script.remove();
    });
  }

  function deleteGoogleAdsCookies() {
    deleteCookiesByPrefixes(["_gcl", "_gac", "_gads", "ide", "fpa", "1p_jar", "_gpi"]);
  }

  function loadBing() {
    var settings = getSettings();
    if (window._ctl_loaded.bing || !settings.bing_tag_id) return;

    window._ctl_loaded.bing = true;
    (function (w, d, t, r, u) {
      var f;
      var n;
      var i;

      w[u] = w[u] || [];

      f = function () {
        var o = { ti: settings.bing_tag_id };
        o.q = w[u];
        w[u] = new UET(o);
        w[u].push("pageLoad");
      };

      n = d.createElement(t);
      n.src = r;
      n.async = 1;
      n.setAttribute("data-ctl-key", "bing");

      n.onload = n.onreadystatechange = function () {
        var s = this.readyState;
        if (!s || s === "loaded" || s === "complete") {
          f();
          n.onload = null;
          n.onreadystatechange = null;
        }
      };

      i = d.getElementsByTagName(t)[0];
      i.parentNode.insertBefore(n, i);
    })(window, document, "script", "https://bat.bing.com/bat.js", "uetq");
  }

  function disableBing() {
    window._ctl_loaded.bing = false;
    deleteLocalStorageKeys([
      "_uetsid",
      "_uetsid_exp",
      "_uetvid",
      "_uetvid_exp"
    ]);
    // Best-effort cleanup for Bing/Clarity identifiers after reject.
    deleteCookiesByPrefixes([
      "_uet",
      "_uetsid",
      "_uetvid",
      "_uetc",
      "ANONCHK",
      "CLID",
      "MR",
      "MUID",
      "_clck",
      "_clsk"
    ]);
    document.querySelectorAll('script[src*="bat.bing.com"],script[src*="clarity.ms"],script[data-ctl-key="bing"]').forEach(function (script) {
      script.remove();
    });
  }

  function loadYouTubeApi() {
    var settings = getSettings();
    if (!settings.youtube_iframe_api) return;

    loadScriptOnce("youtube", "https://www.youtube.com/iframe_api");
  }

  function loadFacebookPixel() {
    // If OneTrust hasn't executed the blocked script yet,
    // don't mark it as loaded.
    if (typeof window.fbq === "function") {
      window._ctl_loaded.facebook = true;

      // If consent was previously revoked, grant it again.
      if (window.fbq.loaded) {
        window.fbq("consent", "grant");
      }
    } else {
      window._ctl_loaded.facebook = false;
    }
  }

  function disableYouTubeApi() {
    window._ctl_loaded.youtube = false;
    // Third-party cookies are not always removable cross-domain, but this clears any same-domain copies.
    deleteCookiesByPrefixes([
      "__secure-rollout_token",
      "__secure-ynid",
      "visitor_info1_live",
      "visitor_privacy_metadata",
      "ysc"
    ]);
    document.querySelectorAll('script[src*="youtube.com/iframe_api"],script[data-ctl-key="youtube"]').forEach(function (script) {
      script.remove();
    });
  }

  function disableFacebookPixel() {
    window._ctl_loaded.facebook = false;
    deleteLocalStorageKeys(["lastExternalReferrer", "lastExternalReferrerTime"]);
    deleteCookiesByPrefixes(["_fbp", "_fbc", "fr"]);

    document
      .querySelectorAll('script[src*="connect.facebook.net"],script[src*="fbevents.js"],script[data-ctl-key="facebook"]')
      .forEach(function (script) {
        script.remove();
      });

    window.fbq = function () {
      window.fbq.queue = window.fbq.queue || [];
      window.fbq.queue.push(arguments);
    };
    window.fbq.queue = [];
    window.fbq.loaded = false;
    window.fbq.version = "2.0";
    window.fbq.push = window.fbq;
    window._fbq = window.fbq;
  }

  function deleteShopifyBuiltInCookies(consentState) {
    var performanceOK = consentState && typeof consentState.performance === "boolean"
      ? consentState.performance
      : isAllowed("C0002");
    var functionalOK = consentState && typeof consentState.functional === "boolean"
      ? consentState.functional
      : isAllowed("C0003");
    var targetingOK = consentState && typeof consentState.targeting === "boolean"
      ? consentState.targeting
      : isAllowed("C0004");

    // Shopify sets these before consent JS can block them; purge when categories are rejected.
    if (!performanceOK) {
      deleteNamedCookies(SHOPIFY_CONSENT_COOKIES.performance);
    }

    if (!functionalOK) {
      deleteNamedCookies(SHOPIFY_CONSENT_COOKIES.functional);
    }

    if (!targetingOK) {
      deleteNamedCookies(SHOPIFY_CONSENT_COOKIES.targeting);
    }
  }

  function disableKlaviyoEmbed() {
    deleteNamedCookies(TARGETING_APP_COOKIES.slice(0, 2));
    deleteCookiesByPrefixes(["__kla"]);
    deleteLocalStorageKeys([
      "$last_referrer",
      "$referrer",
      "__kl_key",
      "kl-post-identification-sync",
      "klaviyoOnsite"
    ]);
    deleteLocalStorageByPrefixes(["klaviyo"]);

    deleteSessionStorageKeys(TARGETING_SESSION_STORAGE_KEYS);
    deleteSessionStorageByPrefixes(["klaviyo"]);

    document.querySelectorAll('script[src*="klaviyo.com"],script[src*="klaviyo-onsite"]').forEach(function (script) {
      script.remove();
    });

    window._learnq = window._learnq || [];
    if (!window._learnq._ctl_stub) {
      var learnqStub = function () {
        learnqStub.q = learnqStub.q || [];
        learnqStub.q.push(arguments);
      };
      learnqStub._ctl_stub = true;
      window._learnq = learnqStub;
    }
  }

  function disableYotpoEmbed() {
    deleteNamedCookies(["yotpo_pixel"]);
    deleteCookiesByPrefixes(["yotpo"].concat(PERFORMANCE_APP_COOKIE_PREFIXES));

    document.querySelectorAll('script[src*="yotpo.com"],script[src*="staticw2.yotpo"]').forEach(function (script) {
      script.remove();
    });
  }

  function disableGorgiasEmbed() {
    deleteLocalStorageByPrefixes(["gorgias."]);
    deleteSessionStorageByPrefixes(["gorgias."]);

    document.querySelectorAll('script[src*="gorgias"]').forEach(function (script) {
      script.remove();
    });
  }

  function disableSmileEmbed() {
    unmountSmileInitializer();
    deleteSessionStorageByPrefixes(["__smile_"]);

    document.querySelectorAll('script[src*="smile.io"],script[src*="smile-ui"]').forEach(function (script) {
      script.remove();
    });
  }

  function runAllStorageCleanup(consentState) {
    applyAppEmbedCookieConsent(consentState);
    applyLocalStorageConsent(consentState);
    applySessionStorageConsent(consentState);
  }

  function scheduleRejectStorageCleanup() {
    runAllStorageCleanup(REJECTED_CONSENT_STATE);
    schedulePostLoadLocalStorageCleanup(REJECTED_CONSENT_STATE);
    schedulePostLoadSessionStorageCleanup(REJECTED_CONSENT_STATE);

    window.setTimeout(function () {
      runAllStorageCleanup(REJECTED_CONSENT_STATE);
    }, 1500);
  }

  // Runs on first page load, every refresh, and every consent change.
  function applyAppEmbedCookieConsent(consentState) {
    var state = resolveConsentState(consentState || {});

    if (!state.targeting) {
      disableKlaviyoEmbed();
      disableYotpoEmbed();
    } else if (!state.performance) {
      deleteCookiesByPrefixes(PERFORMANCE_APP_COOKIE_PREFIXES);
    }

    if (!state.functional) {
      disableGorgiasEmbed();
      disableSmileEmbed();
    }
  }

  function runShopifyBuiltInCookieCleanupOnLoad() {
    // Shopify sets HttpOnly cookies during initial HTML load; sync consent after load
    // so the Customer Privacy API can suppress them when categories are rejected.
    var consentState = {
      performance: isAllowed("C0002"),
      functional: isAllowed("C0003"),
      targeting: isAllowed("C0004")
    };

    syncShopifyConsent();
    deleteShopifyBuiltInCookies(consentState);
    applyAppEmbedCookieConsent(consentState);
    applyLocalStorageConsent(consentState);
    applySessionStorageConsent(consentState);
    schedulePostLoadLocalStorageCleanup(consentState);
    schedulePostLoadSessionStorageCleanup(consentState);
  }

  function applyConsent() {
    var performanceOK = isAllowed("C0002");
    var functionalOK = isAllowed("C0003");
    var targetingOK = isAllowed("C0004");
    var groups = getGroups();

    // Sync Shopify Customer Privacy FIRST
    syncShopifyConsent();

    if (!groups) {
      logConsentIssue("GROUPS_EMPTY", "No OneTrust groups found while applying consent", {
        has_optanon_cookie: /(?:^|;\s*)OptanonConsent=/.test(document.cookie),
        onetrust_active_groups_type: typeof window.OnetrustActiveGroups
      });
    }

    if ((groups.indexOf("C0002") > -1 || groups.indexOf("C0003") > -1 || groups.indexOf("C0004") > -1) && !performanceOK && !functionalOK && !targetingOK) {
      logConsentIssue("GROUP_PARSE_MISMATCH", "Groups string contains categories but all consent checks resolved false", {
        groups: groups
      });
    }

    if (performanceOK) {
      loadGA();
      loadHotjar();
    } else {
      disableGA();
      disableHotjar();
      deleteGoogleAdsCookies();
    }

    if (targetingOK) {
      loadBing();
      loadYouTubeApi();
      loadFacebookPixel();
    } else {
      disableBing();
      disableYouTubeApi();
      disableFacebookPixel();
    }

    if (functionalOK) {
      mountSmileInitializer();
    } else {
      unmountSmileInitializer();
    }

    var consentState = {
      performance: performanceOK,
      functional: functionalOK,
      targeting: targetingOK
    };

    deleteShopifyBuiltInCookies(consentState);
    applyAppEmbedCookieConsent(consentState);
    applyLocalStorageConsent(consentState);
    applySessionStorageConsent(consentState);
    schedulePostLoadLocalStorageCleanup(consentState);
    schedulePostLoadSessionStorageCleanup(consentState);
  }

  window.applyCookieConsent = applyConsent;
  window.isConsentGroupAllowed = isConsentGroupAllowed;
  window.applyLocalStorageConsent = applyLocalStorageConsent;
  window.applySessionStorageConsent = applySessionStorageConsent;
  window.applyAppEmbedCookieConsent = applyAppEmbedCookieConsent;
  window.deleteShopifyBuiltInCookies = deleteShopifyBuiltInCookies;
  window.deleteTargetingLocalStorage = deleteTargetingLocalStorage;
  try {
    applyConsent();
  } catch (err) {
    logConsentError("INITIAL_APPLY_FAILED", err, {
      phase: "initial_load"
    });
  }

  if (document.readyState === "complete") {
    runShopifyBuiltInCookieCleanupOnLoad();
  } else {
    window.addEventListener("load", runShopifyBuiltInCookieCleanupOnLoad);
  }

  window.addEventListener("OneTrustGroupsUpdated", function () {
    try {
      applyConsent();

      if (!isAllowed("C0002") && !isAllowed("C0003") && !isAllowed("C0004")) {
        scheduleRejectStorageCleanup();
      }
    } catch (err) {
      logConsentError("GROUPS_UPDATED_HANDLER_FAILED", err, {
        event: "OneTrustGroupsUpdated"
      });
    }
  });

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target) return;

    if (
      target.closest(".onetrust-accept-btn-handler") ||
      target.closest(".onetrust-reject-all-handler") ||
      target.closest("#onetrust-accept-btn-handler") ||
      target.closest("#onetrust-reject-all-handler") ||
      target.closest(".ot-pc-refuse-all-handler") ||
      target.closest(".ot-pc-accept-all-handler") ||
      target.closest("#onetrust-pc-btn-handler") ||
      target.closest(".save-preference-btn-handler") ||
      target.closest("#accept-recommended-btn-handler")
    ) {
      var action = target.closest(".onetrust-reject-all-handler") ||
        target.closest("#onetrust-reject-all-handler") ||
        target.closest(".ot-pc-refuse-all-handler")
        ? "reject_all"
        : "accept_all";
      setTimeout(function () {
        try {
          applyConsent();

          if (action === "reject_all") {
            scheduleRejectStorageCleanup();
          }

          var snapshot = getConsentSnapshot();
          if (action === "accept_all" && !snapshot.performance && !snapshot.functional && !snapshot.targeting) {
            logConsentIssue("ACCEPT_ALL_NO_GROUP_ENABLED", "Accept all clicked but no non-essential groups are enabled", snapshot);
          }
          if (action === "reject_all" && (snapshot.performance || snapshot.functional || snapshot.targeting)) {
            logConsentIssue("REJECT_ALL_GROUP_STILL_ENABLED", "Reject all clicked but one or more non-essential groups remain enabled", snapshot);
          }
        } catch (err) {
          logConsentError("BANNER_CLICK_APPLY_FAILED", err, {
            action: action
          });
        }
      }, 300);
    }
  });
})();
